import { Unit, UnitTemplate } from '../models';
import { FWWDataLibrary } from '../fww-data-library';

export function getUnitCost(unitLike: Unit | UnitTemplate) {
    let cost = 0;

    const sum = (a, b) => a + b;

    const getCostValue = (item: any, costSoFar?: number) => {
        if (!item || !item.cost) {
            console.log('unrecognised item in getUnitCost', item);
            return 0;
        }
        if (item.costType === 'percent') {
            return Math.round((item.cost / 100) * costSoFar);
        }
        return item.cost;
    };

    if ((unitLike as Unit).unitTemplate) {
        const unit = unitLike as Unit;
        cost = unit.overrideCost ?? unit.unitTemplate.baseCost;
        cost += (unit.options.automatronComponents || []).map((p) => FWWDataLibrary.automatronPieces[p.key].baseCost).reduce(sum, 0);
        cost += unit.options.equipment
            .map((e) => {
                const item = FWWDataLibrary.equipment[e.key];
                if (!item) {
                    console.warn('unrecognised equipment in getUnitCost', e);
                }
                return e.overrideCost ?? getCostValue(item);
            })
            .reduce(sum, 0);

        // Get percentage based costs and do those last
        const equippedPerks = unit.options.perks
            .filter((p) => p.equipped)
            .map((p) => {
                const perk = structuredClone(FWWDataLibrary.perks[p.key]);
                if (typeof p.overrideCost === 'number') {
                    perk.cost = p.overrideCost;
                }
                return perk;
            })
            .sort((a, b) => {
                if (a.costType === 'percent' && b.costType !== 'percent') {
                    return 1;
                }
                if (b.costType === 'percent' && a.costType !== 'percent') {
                    return -1;
                }
                return 0;
            });

        cost += equippedPerks.map((p) => getCostValue(p, cost)).reduce(sum, 0);

        if (unit.derived.leaderCard) {
            cost += unit.derived.leaderCard.cost;
        }
    } else {
        cost = (unitLike as UnitTemplate).baseCost;
    }
    return cost;
}
